import EmblaCarousel from 'embla-carousel';
import { addPrevNextBtnsClickHandlers } from '../utils/EmblaCarouselArrowButtons';
import { addDotBtnsAndClickHandlers } from '../utils/EmblaCarouselDotButton';

export default (node) => {
  const init = () => {
    const emblaNode = node;

    const viewportNode = emblaNode.querySelector('.embla__viewport');
    const prevBtnNode = emblaNode.querySelector('.embla__button--prev');
    const nextBtnNode = emblaNode.querySelector('.embla__button--next');
    const dotsNode = emblaNode.querySelector('.embla__dots');
    const controlsNode = emblaNode.querySelector('.embla__controls');

    const slidesToScroll = emblaNode.dataset.slidesToScroll
      ? Number(emblaNode.dataset.slidesToScroll)
      : 'auto';
    const options = { loop: false, slidesToScroll, align: 'start' };
    const emblaApi = EmblaCarousel(viewportNode, options);

    // Lazy load: defer off-screen slide images until they scroll into view
    const setupLazyLoading = () => {
      const slides = emblaApi.slideNodes();
      const inView = new Set(emblaApi.slidesInView());

      slides.forEach((slide, index) => {
        if (inView.has(index)) return;
        slide.querySelectorAll('img[src]').forEach((img) => {
          img.dataset.lazySrc = img.src;
          img.removeAttribute('src');
        });
      });

      const loadInViewImages = () => {
        const visibleSlides = emblaApi.slidesInView();
        visibleSlides.forEach((index) => {
          slides[index].querySelectorAll('img[data-lazy-src]').forEach((img) => {
            img.src = img.dataset.lazySrc;
            img.removeAttribute('data-lazy-src');
          });
        });
      };

      emblaApi.on('slidesInView', loadInViewImages);
    };

    setupLazyLoading();

    // Progress bar: update translateX based on scroll progress
    const progressBarNode = emblaNode.querySelector(
      '[data-hero-split-progress-bar]'
    );
    if (progressBarNode) {
      const slideCount = emblaApi.scrollSnapList().length;
      if (slideCount > 1) {
        progressBarNode.style.width = `${100 / slideCount}%`;
      }

      const updateProgress = () => {
        const progress = emblaApi.scrollProgress();
        const maxTranslate = (slideCount - 1) * 100;
        const translate = Math.max(
          0,
          Math.min(progress * maxTranslate, maxTranslate)
        );
        progressBarNode.style.transform = `translateX(${translate}%)`;
      };

      emblaApi.on('scroll', updateProgress);
      emblaApi.on('init', updateProgress);
    }

    // Hide controls if there's nothing to scroll
    const updateControlsVisibility = () => {
      if (!controlsNode) return;
      const canScroll = emblaApi.canScrollPrev() || emblaApi.canScrollNext();
      controlsNode.style.display = canScroll ? '' : 'none';
    };

    updateControlsVisibility();
    emblaApi.on('init', updateControlsVisibility);
    emblaApi.on('resize', updateControlsVisibility);

    const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
      emblaApi,
      prevBtnNode,
      nextBtnNode
    );

    const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
      emblaApi,
      dotsNode
    );
  };

  init();
};
